/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetUserCards200ResponseInnerReissueOneOf
 */
export interface GetUserCards200ResponseInnerReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInnerReissueOneOf
     */
    'cardType': GetUserCards200ResponseInnerReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof GetUserCards200ResponseInnerReissueOneOf
     */
    'expiredDate': string;
}

export const GetUserCards200ResponseInnerReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type GetUserCards200ResponseInnerReissueOneOfCardTypeEnum = typeof GetUserCards200ResponseInnerReissueOneOfCardTypeEnum[keyof typeof GetUserCards200ResponseInnerReissueOneOfCardTypeEnum];


